import React, { useMemo, useState } from 'react';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';
import MessageModal from 'pages/student-societies/MessageModal';
import { withAuth } from 'lib/hocs/withAuth';
import { Partnerships } from './Partnerships/Partnerships.component';
import { ExploreCommunities } from './ExploreCommunities/ExploreCommunities.component';

import styles from './PartnershipsWrapper.module.scss';

interface MessageModalProps {
  id: string;
  name: string;
}

const PartnershipsWrapper = () => {
  const [showExploreCommunities, setShowExploreCommunities] =
    useState<boolean>(false);
  const [messageModalData, setMessageModalData] = useState<
    MessageModalProps | undefined
  >(undefined);

  const toggleExploreCommunities = () => {
    setShowExploreCommunities((open) => !open);
  };

  const toggleMessageModal = (data?: MessageModalProps) => {
    setMessageModalData(data);
  };

  const renderContent = useMemo(() => {
    if (showExploreCommunities) {
      return <ExploreCommunities goBack={toggleExploreCommunities} />;
    } else {
      return (
        <Partnerships
          goToExploreCommunities={toggleExploreCommunities}
          onMessageCommunity={toggleMessageModal}
        />
      );
    }
  }, [showExploreCommunities, messageModalData]);

  return (
    <>
      <Head>
        <title>Partnerships | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section
        className={styles.PartnershipsWrapper}
        data-testid="Partnerships"
      >
        {renderContent}
      </section>
      <MessageModal
        isOpen={!!messageModalData}
        onClose={() => toggleMessageModal()}
        student_society_id={messageModalData?.id || ''}
        societyName={messageModalData?.name || ''}
        sponsorshipPlanSelected={null}
      />
    </>
  );
};

const PartnershipsAuthWrapper = withAuth(PartnershipsWrapper);

// @ts-ignore
PartnershipsAuthWrapper.getLayout = getLayout;

export default PartnershipsAuthWrapper;
